import type { IconProps } from "types";

const SortDescent = ({ width = "20", height = "20", color = "#141516" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4577_24366)">
        <path
          d="M16.6671 3.3335V13.3335H19.1671L15.8337 17.5002L12.5004 13.3335H15.0004V3.3335H16.6671ZM10.0004 15.0002V16.6668H2.50041V15.0002H10.0004ZM11.6671 9.16683V10.8335H2.50041V9.16683H11.6671ZM11.6671 3.3335V5.00016H2.50041V3.3335H11.6671Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4577_24366">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SortDescent;
